import thumb from '../../../assets/images/mylist/thumb.png';
import full01 from '../../../assets/images/mylist/full01.png';
import full02 from '../../../assets/images/mylist/full02.png';
import full03 from '../../../assets/images/mylist/full03.png';
import full04 from '../../../assets/images/mylist/full04.png';
import full05 from '../../../assets/images/mylist/full05.png';
import full06 from '../../../assets/images/mylist/full06.png';
import full07 from '../../../assets/images/mylist/full07.png';
import full08 from '../../../assets/images/mylist/full08.png';
import full09 from '../../../assets/images/mylist/full09.png';
import full10 from '../../../assets/images/mylist/full10.png';
import full11 from '../../../assets/images/mylist/full11.png';
import full12 from '../../../assets/images/mylist/full12.png';
import full13 from '../../../assets/images/mylist/full13.png';
import full14 from '../../../assets/images/mylist/full14.png';
import full15 from '../../../assets/images/mylist/full15.png';

const myListData = {
  name: 'MyList',
  description: `A task management web application with synchronization across multiple devices.`,
  skills: ['TypeScript', 'React', 'Redux', 'Node.js'],
  sources: [
    { caption: "MyList Demo", source:"https://user-images.githubusercontent.com/55158465/122650039-92fec800-d128-11eb-9d39-0972217c16c0.gif" },
    { caption: 'Home | MyList', source: full01 },
    { caption: 'Log In | MyList', source: full02 },
    { caption: 'All Boards | MyList', source: full03 },
    { caption: 'Create Board | MyList', source: full04 },
    { caption: 'Search Boards | MyList', source: full05 },
    { caption: 'Search | MyList', source: full06 },
    { caption: 'Board Page | MyList', source: full07 },
    { caption: 'Card Page | MyList', source: full08 },
    { caption: 'Invite Member | MyList', source: full09 },
    { caption: 'Mobile Home | MyList', source: full10 },
    { caption: 'Mobile Login | MyList', source: full11 },
    { caption: 'Mobile All Boards | MyList', source: full12 },
    { caption: 'Mobile Create Board | MyList', source: full13 },
    { caption: 'Mobile Search Boards | MyList', source: full14 },
    { caption: 'Mobile Board Page | MyList', source: full15 },
  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/mylist',
  liveUrl: 'https://mylist-app.netlify.app/',
};

export default myListData;
